import {
  Armchair,
  Fence,
  Flame,
  Lamp,
  Layers,
  ShowerHead,
  SquareStack,
  Sun,
  Tent,
  UtensilsCrossed,
} from 'lucide-react';
import { GARDEN_MAN_MADE_STRUCTURES } from '../lib/gardenDesignOptions';

/** @type {Record<string, typeof Fence>} */
const STRUCTURE_ICONS = {
  'Corridor Shelter': Tent,
  'Swimming Pool': ShowerHead,
  'Stone Retaining Wall': Layers,
  'Wooden Fence': Fence,
  'Mirror Pool': ShowerHead,
  Swing: Armchair,
  'Slate Path': SquareStack,
  'Outdoor Furniture': Armchair,
  Stairs: Layers,
  'Concrete Path': SquareStack,
  Pavilion: Tent,
  'Brick Path': SquareStack,
  'Garden Lights': Lamp,
  'Iron Fence': Fence,
  Fountain: ShowerHead,
  Pergola: Tent,
  'Fire Pit': Flame,
  'Outdoor Kitchen': UtensilsCrossed,
  Decking: SquareStack,
  'Garden Bench': Armchair,
  Gazebo: Tent,
  'Stepping Stones': SquareStack,
  'Privacy Screen': Fence,
};

/**
 * @typedef {{ id: string; label: string; Icon: typeof Fence }} GardenManMadeStructure
 */

/** @type {GardenManMadeStructure[]} */
export const GARDEN_MAN_MADE_STRUCTURE_OPTIONS = GARDEN_MAN_MADE_STRUCTURES.map((label) => ({
  id: label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, ''),
  label,
  Icon: STRUCTURE_ICONS[label] || Sun,
}));
